var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReimbursementListTemplate',{attrs:{"status":2,"tableList":['projectTitle', 'amount', 'procedure', 'method', 'editButton', 'uploadButton', 'deleteButton']}})}
var staticRenderFns = []

export { render, staticRenderFns }